module.exports = __webpack_public_path__ + "static/images/2_cloudy_navigate_day.98a7fd56.jpg";